import React from "react";
import { General } from "../tools/styles"
import FloatCard from "./ui/FloatCard";
import { theme } from "../theme";
import RenderIf from "./RenderIf";

const Metric = ({
  currentValue = "",
  description = "",
  metricArray = [],
  handleChange = function () {
    console.log("no function defined");
  },
}) => {

  // console.log('metric test', metricArray)

  return (
    <General.BlockContainer>
      <General.Block>
        <FloatCard width="300px">
          <General.InputCont>
            <General.Select
              name="metric"
              onChange={handleChange}
              value={currentValue}
            >
              <option value="">-- Please choose an option</option>
              {metricArray.map(metric => (
                <option key={metric.id} value={metric.metric}>
                  {metric.metric}
                </option>
              ))}
            </General.Select>
          </General.InputCont>
        </FloatCard>
      </General.Block>
      <General.Block color={theme.colors.grey4}>
        <div>
          <h2>Metric</h2>
          <RenderIf isTrue={description.length > 0}>
            <General.LimitText width="250px">{description}</General.LimitText>
          </RenderIf>
        </div>
      </General.Block>
    </General.BlockContainer>
  );
};

export default Metric;
